import React from 'react';
import ReactDOM from 'react-dom/client';
import { EventType } from '@azure/msal-browser';
import type { AuthenticationResult } from '@azure/msal-browser';
import { msalInstance } from './services/msalInstance';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

function render() {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// ── MSAL bootstrap ────────────────────────────────────────────────────────────
//
// Initialize MSAL and finish processing any redirect response BEFORE React
// mounts. Rendering early let API requests fire through the axios interceptor
// (services/api.ts) while MSAL was still handling the redirect — a redundant
// acquireTokenRedirect in that window discarded the just-completed sign-in and
// bounced the user back to Entra a second time.
//
// We also set an active account here (and keep it in sync via events) so the
// interceptor and MsalProvider always agree on which account to use.

async function bootstrap() {
  await msalInstance.initialize();

  try {
    const result = await msalInstance.handleRedirectPromise();
    if (result?.account) {
      msalInstance.setActiveAccount(result.account);
    }
  } catch (err) {
    // Redirect handling failed — render anyway; the app shows the signed-out
    // screen and the user can retry from the Sign In button.
    console.error('MSAL redirect handling failed:', err);
  }

  if (!msalInstance.getActiveAccount()) {
    const [firstAccount] = msalInstance.getAllAccounts();
    if (firstAccount) {
      msalInstance.setActiveAccount(firstAccount);
    }
  }

  msalInstance.addEventCallback((event) => {
    if (
      (event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
      event.payload
    ) {
      const payload = event.payload as AuthenticationResult;
      if (payload.account) {
        msalInstance.setActiveAccount(payload.account);
      }
    }
  });

  render();
}

bootstrap();
